/* eslint-disable react/prop-types */
import styled from 'styled-components';
import React from 'react';
import Text from '../../../../common/components/base/Text';
import { theme } from '../../../../common/utilsClient/cssHelpers';

const Component = styled.div`
  &:not(:last-child)::after {
    content: '·';
    margin: 0 ${theme('space.1')};
  }

  svg {
    height: 1em;
    width: 1em;
  }
`;

const DashboardVariableItem = ({ label, value }) => {
  return value ? (
    <Component>
      <span>
        <span className="text-xs font-medium">{label} </span>
        <span className="text-sm">{value}</span>
      </span>
    </Component>
  ) : null;
};

DashboardVariableItem.propTypes = {};

DashboardVariableItem.defaultProps = {};

export default DashboardVariableItem;
